import { useEffect, useState } from "react";
import api from "../api/client";
type Sub = { subscriptionId:string; displayName:string; state:string };
export function useAzureSubscriptions() {
  const [data, setData] = useState<Sub[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    let mounted = true;
    api.get("/azure/subscriptions")
      .then(r => mounted && setData(r.data?.value || []))
      .catch(e => mounted && setError(e.message))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);
  return { data, loading, error };
}
